// ------------------ COUNTRY CODE ------------------ //
import { isTruthy } from '../typing.js';
import { ARGENTINA_PROVINCE_CODES, AUSTRALIA_PROVINCE_CODES, AUSTRIA_PROVINCE_CODES, BELGIUM_PROVINCE_CODES, BOLIVIA_PROVINCE_CODES, BRAZIL_PROVINCE_CODES, CANADA_PROVINCE_CODES, CHILE_PROVINCE_CODES, COLOMBIA_PROVINCE_CODES, DENMARK_PROVINCE_CODES, ECUADOR_PROVINCE_CODES, FINLAND_PROVINCE_CODES, FRANCE_PROVINCE_CODES, GERMANY_PROVINCE_CODES, HONG_KONG_PROVINCE_CODES, IRELAND_PROVINCE_CODES, ITALY_PROVINCE_CODES, JAPAN_PROVINCE_CODES, KOREA_REPUBLIC_OF_PROVINCE_CODES, MALAYSIA_PROVINCE_CODES, MEXICO_PROVINCE_CODES, NEW_ZEALAND_PROVINCE_CODES, NORWAY_PROVINCE_CODES, PARAGUAY_PROVINCE_CODES, PERU_PROVINCE_CODES, PORTUGAL_PROVINCE_CODES, SPAIN_PROVINCE_CODES, SWEDEN_PROVINCE_CODES, SWITZERLAND_PROVINCE_CODES, UNITED_ARAB_EMIRATES_PROVINCE_CODES, UNITED_KINGDOM_PROVINCE_CODES, UNITED_STATES_PROVINCE_CODES, URUGUAY_PROVINCE_CODES, VENEZUELA_PROVINCE_CODES, } from './provinces.js';
export const EuCountryCodes = [
    'AT', // Austria
    'BE', // Belgium
    'BG', // Bulgaria
    'HR', // Croatia
    'CY', // Cyprus
    'CZ', // Czechia
    'DK', // Denmark
    'EE', // Estonia
    'FI', // Finland
    'FR', // France
    'DE', // Germany
    'GR', // Greece
    'HU', // Hungary
    'IE', // Ireland
    'IT', // Italy
    'LV', // Latvia
    'LT', // Lithuania
    'LU', // Luxembourg
    'MT', // Malta
    'NL', // Netherlands
    'PL', // Poland
    'PT', // Portugal
    'RO', // Romania
    'SK', // Slovakia
    'SI', // Slovenia
    'ES', // Spain
    'SE', // Sweden
];
/**
 * [`CountryCode` Enum](https://shopify.dev/docs/api/admin-graphql/2024-10/enums/CountryCode)
 *
 * ISO 3166-1 alpha-2 country codes.
 */
export const CountryCode = {
    /** Ascension Island. */
    AC: 'AC',
    /** Andorra. */
    AD: 'AD',
    /** United Arab Emirates. */
    AE: 'AE',
    /** Afghanistan. */
    AF: 'AF',
    /** Antigua & Barbuda. */
    AG: 'AG',
    /** Anguilla. */
    AI: 'AI',
    /** Albania. */
    AL: 'AL',
    /** Armenia. */
    AM: 'AM',
    /** Netherlands Antilles. */
    AN: 'AN',
    /** Angola. */
    AO: 'AO',
    /** Argentina. */
    AR: 'AR',
    /** Austria. */
    AT: 'AT',
    /** Australia. */
    AU: 'AU',
    /** Aruba. */
    AW: 'AW',
    /** Åland Islands. */
    AX: 'AX',
    /** Azerbaijan. */
    AZ: 'AZ',
    /** Bosnia & Herzegovina. */
    BA: 'BA',
    /** Barbados. */
    BB: 'BB',
    /** Bangladesh. */
    BD: 'BD',
    /** Belgium. */
    BE: 'BE',
    /** Burkina Faso. */
    BF: 'BF',
    /** Bulgaria. */
    BG: 'BG',
    /** Bahrain. */
    BH: 'BH',
    /** Burundi. */
    BI: 'BI',
    /** Benin. */
    BJ: 'BJ',
    /** St. Barthélemy. */
    BL: 'BL',
    /** Bermuda. */
    BM: 'BM',
    /** Brunei. */
    BN: 'BN',
    /** Bolivia. */
    BO: 'BO',
    /** Caribbean Netherlands. */
    BQ: 'BQ',
    /** Brazil. */
    BR: 'BR',
    /** Bahamas. */
    BS: 'BS',
    /** Bhutan. */
    BT: 'BT',
    /** Bouvet Island. */
    BV: 'BV',
    /** Botswana. */
    BW: 'BW',
    /** Belarus. */
    BY: 'BY',
    /** Belize. */
    BZ: 'BZ',
    /** Canada. */
    CA: 'CA',
    /** Cocos (Keeling) Islands. */
    CC: 'CC',
    /** Congo - Kinshasa. */
    CD: 'CD',
    /** Central African Republic. */
    CF: 'CF',
    /** Congo - Brazzaville. */
    CG: 'CG',
    /** Switzerland. */
    CH: 'CH',
    /** Côte d’Ivoire. */
    CI: 'CI',
    /** Cook Islands. */
    CK: 'CK',
    /** Chile. */
    CL: 'CL',
    /** Cameroon. */
    CM: 'CM',
    /** China. */
    CN: 'CN',
    /** Colombia. */
    CO: 'CO',
    /** Costa Rica. */
    CR: 'CR',
    /** Cuba. */
    CU: 'CU',
    /** Cape Verde. */
    CV: 'CV',
    /** Curaçao. */
    CW: 'CW',
    /** Christmas Island. */
    CX: 'CX',
    /** Cyprus. */
    CY: 'CY',
    /** Czechia. */
    CZ: 'CZ',
    /** Germany. */
    DE: 'DE',
    /** Djibouti. */
    DJ: 'DJ',
    /** Denmark. */
    DK: 'DK',
    /** Dominica. */
    DM: 'DM',
    /** Dominican Republic. */
    DO: 'DO',
    /** Algeria. */
    DZ: 'DZ',
    /** Ecuador. */
    EC: 'EC',
    /** Estonia. */
    EE: 'EE',
    /** Egypt. */
    EG: 'EG',
    /** Western Sahara. */
    EH: 'EH',
    /** Eritrea. */
    ER: 'ER',
    /** Spain. */
    ES: 'ES',
    /** Ethiopia. */
    ET: 'ET',
    /** Finland. */
    FI: 'FI',
    /** Fiji. */
    FJ: 'FJ',
    /** Falkland Islands. */
    FK: 'FK',
    /** Faroe Islands. */
    FO: 'FO',
    /** France. */
    FR: 'FR',
    /** Gabon. */
    GA: 'GA',
    /** United Kingdom. */
    GB: 'GB',
    /** Grenada. */
    GD: 'GD',
    /** Georgia. */
    GE: 'GE',
    /** French Guiana. */
    GF: 'GF',
    /** Guernsey. */
    GG: 'GG',
    /** Ghana. */
    GH: 'GH',
    /** Gibraltar. */
    GI: 'GI',
    /** Greenland. */
    GL: 'GL',
    /** Gambia. */
    GM: 'GM',
    /** Guinea. */
    GN: 'GN',
    /** Guadeloupe. */
    GP: 'GP',
    /** Equatorial Guinea. */
    GQ: 'GQ',
    /** Greece. */
    GR: 'GR',
    /** South Georgia & South Sandwich Islands. */
    GS: 'GS',
    /** Guatemala. */
    GT: 'GT',
    /** Guinea-Bissau. */
    GW: 'GW',
    /** Guyana. */
    GY: 'GY',
    /** Hong Kong SAR. */
    HK: 'HK',
    /** Heard & McDonald Islands. */
    HM: 'HM',
    /** Honduras. */
    HN: 'HN',
    /** Croatia. */
    HR: 'HR',
    /** Haiti. */
    HT: 'HT',
    /** Hungary. */
    HU: 'HU',
    /** Indonesia. */
    ID: 'ID',
    /** Ireland. */
    IE: 'IE',
    /** Israel. */
    IL: 'IL',
    /** Isle of Man. */
    IM: 'IM',
    /** India. */
    IN: 'IN',
    /** British Indian Ocean Territory. */
    IO: 'IO',
    /** Iraq. */
    IQ: 'IQ',
    /** Iran. */
    IR: 'IR',
    /** Iceland. */
    IS: 'IS',
    /** Italy. */
    IT: 'IT',
    /** Jersey. */
    JE: 'JE',
    /** Jamaica. */
    JM: 'JM',
    /** Jordan. */
    JO: 'JO',
    /** Japan. */
    JP: 'JP',
    /** Kenya. */
    KE: 'KE',
    /** Kyrgyzstan. */
    KG: 'KG',
    /** Cambodia. */
    KH: 'KH',
    /** Kiribati. */
    KI: 'KI',
    /** Comoros. */
    KM: 'KM',
    /** St. Kitts & Nevis. */
    KN: 'KN',
    /** North Korea. */
    KP: 'KP',
    /** South Korea. */
    KR: 'KR',
    /** Kuwait. */
    KW: 'KW',
    /** Cayman Islands. */
    KY: 'KY',
    /** Kazakhstan. */
    KZ: 'KZ',
    /** Laos. */
    LA: 'LA',
    /** Lebanon. */
    LB: 'LB',
    /** St. Lucia. */
    LC: 'LC',
    /** Liechtenstein. */
    LI: 'LI',
    /** Sri Lanka. */
    LK: 'LK',
    /** Liberia. */
    LR: 'LR',
    /** Lesotho. */
    LS: 'LS',
    /** Lithuania. */
    LT: 'LT',
    /** Luxembourg. */
    LU: 'LU',
    /** Latvia. */
    LV: 'LV',
    /** Libya. */
    LY: 'LY',
    /** Morocco. */
    MA: 'MA',
    /** Monaco. */
    MC: 'MC',
    /** Moldova. */
    MD: 'MD',
    /** Montenegro. */
    ME: 'ME',
    /** St. Martin. */
    MF: 'MF',
    /** Madagascar. */
    MG: 'MG',
    /** North Macedonia. */
    MK: 'MK',
    /** Mali. */
    ML: 'ML',
    /** Myanmar (Burma). */
    MM: 'MM',
    /** Mongolia. */
    MN: 'MN',
    /** Macao SAR. */
    MO: 'MO',
    /** Martinique. */
    MQ: 'MQ',
    /** Mauritania. */
    MR: 'MR',
    /** Montserrat. */
    MS: 'MS',
    /** Malta. */
    MT: 'MT',
    /** Mauritius. */
    MU: 'MU',
    /** Maldives. */
    MV: 'MV',
    /** Malawi. */
    MW: 'MW',
    /** Mexico. */
    MX: 'MX',
    /** Malaysia. */
    MY: 'MY',
    /** Mozambique. */
    MZ: 'MZ',
    /** Namibia. */
    NA: 'NA',
    /** New Caledonia. */
    NC: 'NC',
    /** Niger. */
    NE: 'NE',
    /** Norfolk Island. */
    NF: 'NF',
    /** Nigeria. */
    NG: 'NG',
    /** Nicaragua. */
    NI: 'NI',
    /** Netherlands. */
    NL: 'NL',
    /** Norway. */
    NO: 'NO',
    /** Nepal. */
    NP: 'NP',
    /** Nauru. */
    NR: 'NR',
    /** Niue. */
    NU: 'NU',
    /** New Zealand. */
    NZ: 'NZ',
    /** Oman. */
    OM: 'OM',
    /** Panama. */
    PA: 'PA',
    /** Peru. */
    PE: 'PE',
    /** French Polynesia. */
    PF: 'PF',
    /** Papua New Guinea. */
    PG: 'PG',
    /** Philippines. */
    PH: 'PH',
    /** Pakistan. */
    PK: 'PK',
    /** Poland. */
    PL: 'PL',
    /** St. Pierre & Miquelon. */
    PM: 'PM',
    /** Pitcairn Islands. */
    PN: 'PN',
    /** Palestinian Territories. */
    PS: 'PS',
    /** Portugal. */
    PT: 'PT',
    /** Paraguay. */
    PY: 'PY',
    /** Qatar. */
    QA: 'QA',
    /** Réunion. */
    RE: 'RE',
    /** Romania. */
    RO: 'RO',
    /** Serbia. */
    RS: 'RS',
    /** Russia. */
    RU: 'RU',
    /** Rwanda. */
    RW: 'RW',
    /** Saudi Arabia. */
    SA: 'SA',
    /** Solomon Islands. */
    SB: 'SB',
    /** Seychelles. */
    SC: 'SC',
    /** Sudan. */
    SD: 'SD',
    /** Sweden. */
    SE: 'SE',
    /** Singapore. */
    SG: 'SG',
    /** St. Helena. */
    SH: 'SH',
    /** Slovenia. */
    SI: 'SI',
    /** Svalbard & Jan Mayen. */
    SJ: 'SJ',
    /** Slovakia. */
    SK: 'SK',
    /** Sierra Leone. */
    SL: 'SL',
    /** San Marino. */
    SM: 'SM',
    /** Senegal. */
    SN: 'SN',
    /** Somalia. */
    SO: 'SO',
    /** Suriname. */
    SR: 'SR',
    /** South Sudan. */
    SS: 'SS',
    /** São Tomé & Príncipe. */
    ST: 'ST',
    /** El Salvador. */
    SV: 'SV',
    /** Sint Maarten. */
    SX: 'SX',
    /** Syria. */
    SY: 'SY',
    /** Eswatini. */
    SZ: 'SZ',
    /** Tristan da Cunha. */
    TA: 'TA',
    /** Turks & Caicos Islands. */
    TC: 'TC',
    /** Chad. */
    TD: 'TD',
    /** French Southern Territories. */
    TF: 'TF',
    /** Togo. */
    TG: 'TG',
    /** Thailand. */
    TH: 'TH',
    /** Tajikistan. */
    TJ: 'TJ',
    /** Tokelau. */
    TK: 'TK',
    /** Timor-Leste. */
    TL: 'TL',
    /** Turkmenistan. */
    TM: 'TM',
    /** Tunisia. */
    TN: 'TN',
    /** Tonga. */
    TO: 'TO',
    /** Türkiye. */
    TR: 'TR',
    /** Trinidad & Tobago. */
    TT: 'TT',
    /** Tuvalu. */
    TV: 'TV',
    /** Taiwan. */
    TW: 'TW',
    /** Tanzania. */
    TZ: 'TZ',
    /** Ukraine. */
    UA: 'UA',
    /** Uganda. */
    UG: 'UG',
    /** U.S. Outlying Islands. */
    UM: 'UM',
    /** United States. */
    US: 'US',
    /** Uruguay. */
    UY: 'UY',
    /** Uzbekistan. */
    UZ: 'UZ',
    /** Vatican City. */
    VA: 'VA',
    /** St. Vincent & Grenadines. */
    VC: 'VC',
    /** Venezuela. */
    VE: 'VE',
    /** British Virgin Islands. */
    VG: 'VG',
    /** Vietnam. */
    VN: 'VN',
    /** Vanuatu. */
    VU: 'VU',
    /** Wallis & Futuna. */
    WF: 'WF',
    /** Samoa. */
    WS: 'WS',
    /** Kosovo. */
    XK: 'XK',
    /** Yemen. */
    YE: 'YE',
    /** Mayotte. */
    YT: 'YT',
    /** South Africa. */
    ZA: 'ZA',
    /** Zambia. */
    ZM: 'ZM',
    /** Zimbabwe. */
    ZW: 'ZW',
    /** Unknown Region. */
    ZZ: 'ZZ',
};
export const constructProvinceValue = ({ countryCode, provinceCode, }) => (countryCode && provinceCode ? `${countryCode}-${provinceCode}` : null);
const mapProvinces = (provinces) => Object.entries(provinces).map(([code, name]) => ({
    code,
    name,
}));
export const geoCountryCodes = {
    [CountryCode.US]: {
        code: CountryCode.US,
        name: 'United States',
        provinces: mapProvinces(UNITED_STATES_PROVINCE_CODES),
    },
    [CountryCode.CA]: {
        code: CountryCode.CA,
        name: 'Canada',
        provinces: mapProvinces(CANADA_PROVINCE_CODES),
    },
    [CountryCode.AU]: {
        code: CountryCode.AU,
        name: 'Australia',
        provinces: mapProvinces(AUSTRALIA_PROVINCE_CODES),
    },
    [CountryCode.AF]: {
        code: CountryCode.AF,
        name: 'Afghanistan',
        provinces: [],
    },
    [CountryCode.AX]: {
        code: CountryCode.AX,
        name: 'Aland Islands',
        provinces: [],
    },
    [CountryCode.AL]: {
        code: CountryCode.AL,
        name: 'Albania',
        provinces: [],
    },
    [CountryCode.DZ]: {
        code: CountryCode.DZ,
        name: 'Algeria',
        provinces: [],
    },
    [CountryCode.AD]: {
        code: CountryCode.AD,
        name: 'Andorra',
        provinces: [],
    },
    [CountryCode.AO]: {
        code: CountryCode.AO,
        name: 'Angola',
        provinces: [],
    },
    [CountryCode.AI]: {
        code: CountryCode.AI,
        name: 'Anguilla',
        provinces: [],
    },
    [CountryCode.AG]: {
        code: CountryCode.AG,
        name: 'Antigua and Barbuda',
        provinces: [],
    },
    [CountryCode.AR]: {
        code: CountryCode.AR,
        name: 'Argentina',
        provinces: mapProvinces(ARGENTINA_PROVINCE_CODES),
    },
    [CountryCode.AM]: {
        code: CountryCode.AM,
        name: 'Armenia',
        provinces: [],
    },
    [CountryCode.AW]: {
        code: CountryCode.AW,
        name: 'Aruba',
        provinces: [],
    },
    [CountryCode.AT]: {
        code: CountryCode.AT,
        name: 'Austria',
        provinces: mapProvinces(AUSTRIA_PROVINCE_CODES),
    },
    [CountryCode.AZ]: {
        code: CountryCode.AZ,
        name: 'Azerbaijan',
        provinces: [],
    },
    [CountryCode.BS]: {
        code: CountryCode.BS,
        name: 'Bahamas',
        provinces: [],
    },
    [CountryCode.BH]: {
        code: CountryCode.BH,
        name: 'Bahrain',
        provinces: [],
    },
    [CountryCode.BD]: {
        code: CountryCode.BD,
        name: 'Bangladesh',
        provinces: [],
    },
    [CountryCode.BB]: {
        code: CountryCode.BB,
        name: 'Barbados',
        provinces: [],
    },
    [CountryCode.BY]: {
        code: CountryCode.BY,
        name: 'Belarus',
        provinces: [],
    },
    [CountryCode.BE]: {
        code: CountryCode.BE,
        name: 'Belgium',
        provinces: mapProvinces(BELGIUM_PROVINCE_CODES),
    },
    [CountryCode.BZ]: {
        code: CountryCode.BZ,
        name: 'Belize',
        provinces: [],
    },
    [CountryCode.BJ]: {
        code: CountryCode.BJ,
        name: 'Benin',
        provinces: [],
    },
    [CountryCode.BM]: {
        code: CountryCode.BM,
        name: 'Bermuda',
        provinces: [],
    },
    [CountryCode.BT]: {
        code: CountryCode.BT,
        name: 'Bhutan',
        provinces: [],
    },
    [CountryCode.BO]: {
        code: CountryCode.BO,
        name: 'Bolivia',
        provinces: mapProvinces(BOLIVIA_PROVINCE_CODES),
    },
    [CountryCode.BA]: {
        code: CountryCode.BA,
        name: 'Bosnia and Herzegovina',
        provinces: [],
    },
    [CountryCode.BW]: {
        code: CountryCode.BW,
        name: 'Botswana',
        provinces: [],
    },
    [CountryCode.BV]: {
        code: CountryCode.BV,
        name: 'Bouvet Island',
        provinces: [],
    },
    [CountryCode.BR]: {
        code: CountryCode.BR,
        name: 'Brazil',
        provinces: mapProvinces(BRAZIL_PROVINCE_CODES),
    },
    [CountryCode.IO]: {
        code: CountryCode.IO,
        name: 'British Indian Ocean Territory',
        provinces: [],
    },
    [CountryCode.BN]: {
        code: CountryCode.BN,
        name: 'Brunei Darussalam',
        provinces: [],
    },
    [CountryCode.BG]: {
        code: CountryCode.BG,
        name: 'Bulgaria',
        provinces: [],
    },
    [CountryCode.BF]: {
        code: CountryCode.BF,
        name: 'Burkina Faso',
        provinces: [],
    },
    [CountryCode.BI]: {
        code: CountryCode.BI,
        name: 'Burundi',
        provinces: [],
    },
    [CountryCode.KH]: {
        code: CountryCode.KH,
        name: 'Cambodia',
        provinces: [],
    },
    [CountryCode.CM]: {
        code: CountryCode.CM,
        name: 'Cameroon',
        provinces: [],
    },
    [CountryCode.CV]: {
        code: CountryCode.CV,
        name: 'Cape Verde',
        provinces: [],
    },
    [CountryCode.KY]: {
        code: CountryCode.KY,
        name: 'Cayman Islands',
        provinces: [],
    },
    [CountryCode.CF]: {
        code: CountryCode.CF,
        name: 'Central African Republic',
        provinces: [],
    },
    [CountryCode.TD]: { code: CountryCode.TD, name: 'Chad', provinces: [] },
    [CountryCode.CL]: {
        code: CountryCode.CL,
        name: 'Chile',
        provinces: mapProvinces(CHILE_PROVINCE_CODES),
    },
    [CountryCode.CN]: {
        code: CountryCode.CN,
        name: 'China',
        provinces: [],
    },
    [CountryCode.CX]: {
        code: CountryCode.CX,
        name: 'Christmas Island',
        provinces: [],
    },
    [CountryCode.CC]: {
        code: CountryCode.CC,
        name: 'Cocos (Keeling) Islands',
        provinces: [],
    },
    [CountryCode.CO]: {
        code: CountryCode.CO,
        name: 'Colombia',
        provinces: mapProvinces(COLOMBIA_PROVINCE_CODES),
    },
    [CountryCode.KM]: {
        code: CountryCode.KM,
        name: 'Comoros',
        provinces: [],
    },
    [CountryCode.CG]: {
        code: CountryCode.CG,
        name: 'Congo',
        provinces: [],
    },
    [CountryCode.CD]: {
        code: CountryCode.CD,
        name: 'Congo, The Democratic Republic of the',
        provinces: [],
    },
    [CountryCode.CK]: {
        code: CountryCode.CK,
        name: 'Cook Islands',
        provinces: [],
    },
    [CountryCode.CR]: {
        code: CountryCode.CR,
        name: 'Costa Rica',
        provinces: [],
    },
    [CountryCode.CI]: {
        code: CountryCode.CI,
        name: 'Cote D"Ivoire',
        provinces: [],
    },
    [CountryCode.HR]: {
        code: CountryCode.HR,
        name: 'Croatia',
        provinces: [],
    },
    [CountryCode.CU]: { code: CountryCode.CU, name: 'Cuba', provinces: [] },
    [CountryCode.CY]: {
        code: CountryCode.CY,
        name: 'Cyprus',
        provinces: [],
    },
    [CountryCode.CZ]: {
        code: CountryCode.CZ,
        name: 'Czech Republic',
        provinces: [],
    },
    [CountryCode.DK]: {
        code: CountryCode.DK,
        name: 'Denmark',
        provinces: mapProvinces(DENMARK_PROVINCE_CODES),
    },
    [CountryCode.DJ]: {
        code: CountryCode.DJ,
        name: 'Djibouti',
        provinces: [],
    },
    [CountryCode.DM]: {
        code: CountryCode.DM,
        name: 'Dominica',
        provinces: [],
    },
    [CountryCode.DO]: {
        code: CountryCode.DO,
        name: 'Dominican Republic',
        provinces: [],
    },
    [CountryCode.EC]: {
        code: CountryCode.EC,
        name: 'Ecuador',
        provinces: mapProvinces(ECUADOR_PROVINCE_CODES),
    },
    [CountryCode.EG]: {
        code: CountryCode.EG,
        name: 'Egypt',
        provinces: [],
    },
    [CountryCode.SV]: {
        code: CountryCode.SV,
        name: 'El Salvador',
        provinces: [],
    },
    [CountryCode.GQ]: {
        code: CountryCode.GQ,
        name: 'Equatorial Guinea',
        provinces: [],
    },
    [CountryCode.ER]: {
        code: CountryCode.ER,
        name: 'Eritrea',
        provinces: [],
    },
    [CountryCode.EE]: {
        code: CountryCode.EE,
        name: 'Estonia',
        provinces: [],
    },
    [CountryCode.ET]: {
        code: CountryCode.ET,
        name: 'Ethiopia',
        provinces: [],
    },
    [CountryCode.FK]: {
        code: CountryCode.FK,
        name: 'Falkland Islands (Malvinas)',
        provinces: [],
    },
    [CountryCode.FO]: {
        code: CountryCode.FO,
        name: 'Faroe Islands',
        provinces: [],
    },
    [CountryCode.FJ]: { code: CountryCode.FJ, name: 'Fiji', provinces: [] },
    [CountryCode.FI]: {
        code: CountryCode.FI,
        name: 'Finland',
        provinces: mapProvinces(FINLAND_PROVINCE_CODES),
    },
    [CountryCode.FR]: {
        code: CountryCode.FR,
        name: 'France',
        provinces: mapProvinces(FRANCE_PROVINCE_CODES),
    },
    [CountryCode.GF]: {
        code: CountryCode.GF,
        name: 'French Guiana',
        provinces: [],
    },
    [CountryCode.PF]: {
        code: CountryCode.PF,
        name: 'French Polynesia',
        provinces: [],
    },
    [CountryCode.TF]: {
        code: CountryCode.TF,
        name: 'French Southern Territories',
        provinces: [],
    },
    [CountryCode.GA]: {
        code: CountryCode.GA,
        name: 'Gabon',
        provinces: [],
    },
    [CountryCode.GM]: {
        code: CountryCode.GM,
        name: 'Gambia',
        provinces: [],
    },
    [CountryCode.GE]: {
        code: CountryCode.GE,
        name: 'Georgia',
        provinces: [],
    },
    [CountryCode.DE]: {
        code: CountryCode.DE,
        name: 'Germany',
        provinces: mapProvinces(GERMANY_PROVINCE_CODES),
    },
    [CountryCode.GH]: {
        code: CountryCode.GH,
        name: 'Ghana',
        provinces: [],
    },
    [CountryCode.GI]: {
        code: CountryCode.GI,
        name: 'Gibraltar',
        provinces: [],
    },
    [CountryCode.GR]: {
        code: CountryCode.GR,
        name: 'Greece',
        provinces: [],
    },
    [CountryCode.GL]: {
        code: CountryCode.GL,
        name: 'Greenland',
        provinces: [],
    },
    [CountryCode.GD]: {
        code: CountryCode.GD,
        name: 'Grenada',
        provinces: [],
    },
    [CountryCode.GP]: {
        code: CountryCode.GP,
        name: 'Guadeloupe',
        provinces: [],
    },
    [CountryCode.GT]: {
        code: CountryCode.GT,
        name: 'Guatemala',
        provinces: [],
    },
    [CountryCode.GG]: {
        code: CountryCode.GG,
        name: 'Guernsey',
        provinces: [],
    },
    [CountryCode.GN]: {
        code: CountryCode.GN,
        name: 'Guinea',
        provinces: [],
    },
    [CountryCode.GW]: {
        code: CountryCode.GW,
        name: 'Guinea-Bissau',
        provinces: [],
    },
    [CountryCode.GY]: {
        code: CountryCode.GY,
        name: 'Guyana',
        provinces: [],
    },
    [CountryCode.HT]: {
        code: CountryCode.HT,
        name: 'Haiti',
        provinces: [],
    },
    [CountryCode.HM]: {
        code: CountryCode.HM,
        name: 'Heard Island and Mcdonald Islands',
        provinces: [],
    },
    [CountryCode.VA]: {
        code: CountryCode.VA,
        name: 'Holy See (Vatican City State)',
        provinces: [],
    },
    [CountryCode.HN]: {
        code: CountryCode.HN,
        name: 'Honduras',
        provinces: [],
    },
    [CountryCode.HK]: {
        code: CountryCode.HK,
        name: 'Hong Kong',
        provinces: mapProvinces(HONG_KONG_PROVINCE_CODES),
    },
    [CountryCode.HU]: {
        code: CountryCode.HU,
        name: 'Hungary',
        provinces: [],
    },
    [CountryCode.IS]: {
        code: CountryCode.IS,
        name: 'Iceland',
        provinces: [],
    },
    [CountryCode.IN]: {
        code: CountryCode.IN,
        name: 'India',
        provinces: [],
    },
    [CountryCode.ID]: {
        code: CountryCode.ID,
        name: 'Indonesia',
        provinces: [],
    },
    [CountryCode.IR]: {
        code: CountryCode.IR,
        name: 'Iran, Islamic Republic Of',
        provinces: [],
    },
    [CountryCode.IQ]: { code: CountryCode.IQ, name: 'Iraq', provinces: [] },
    [CountryCode.IE]: {
        code: CountryCode.IE,
        name: 'Ireland',
        provinces: mapProvinces(IRELAND_PROVINCE_CODES),
    },
    [CountryCode.IM]: {
        code: CountryCode.IM,
        name: 'Isle of Man',
        provinces: [],
    },
    [CountryCode.IL]: {
        code: CountryCode.IL,
        name: 'Israel',
        provinces: [],
    },
    [CountryCode.IT]: {
        code: CountryCode.IT,
        name: 'Italy',
        provinces: mapProvinces(ITALY_PROVINCE_CODES),
    },
    [CountryCode.JM]: {
        code: CountryCode.JM,
        name: 'Jamaica',
        provinces: [],
    },
    [CountryCode.JP]: {
        code: CountryCode.JP,
        name: 'Japan',
        provinces: mapProvinces(JAPAN_PROVINCE_CODES),
    },
    [CountryCode.JE]: {
        code: CountryCode.JE,
        name: 'Jersey',
        provinces: [],
    },
    [CountryCode.JO]: {
        code: CountryCode.JO,
        name: 'Jordan',
        provinces: [],
    },
    [CountryCode.KZ]: {
        code: CountryCode.KZ,
        name: 'Kazakhstan',
        provinces: [],
    },
    [CountryCode.KE]: {
        code: CountryCode.KE,
        name: 'Kenya',
        provinces: [],
    },
    [CountryCode.KI]: {
        code: CountryCode.KI,
        name: 'Kiribati',
        provinces: [],
    },
    [CountryCode.KP]: {
        code: CountryCode.KP,
        name: `Korea, Democratic People's Republic of`,
        provinces: mapProvinces(KOREA_REPUBLIC_OF_PROVINCE_CODES),
    },
    [CountryCode.KR]: {
        code: CountryCode.KR,
        name: 'Korea, Republic of',
        provinces: [],
    },
    [CountryCode.KW]: {
        code: CountryCode.KW,
        name: 'Kuwait',
        provinces: [],
    },
    [CountryCode.KG]: {
        code: CountryCode.KG,
        name: 'Kyrgyzstan',
        provinces: [],
    },
    [CountryCode.LA]: {
        code: CountryCode.LA,
        name: 'Lao People"s Democratic Republic',
        provinces: [],
    },
    [CountryCode.LV]: {
        code: CountryCode.LV,
        name: 'Latvia',
        provinces: [],
    },
    [CountryCode.LB]: {
        code: CountryCode.LB,
        name: 'Lebanon',
        provinces: [],
    },
    [CountryCode.LS]: {
        code: CountryCode.LS,
        name: 'Lesotho',
        provinces: [],
    },
    [CountryCode.LR]: {
        code: CountryCode.LR,
        name: 'Liberia',
        provinces: [],
    },
    [CountryCode.LY]: {
        code: CountryCode.LY,
        name: 'Libyan Arab Jamahiriya',
        provinces: [],
    },
    [CountryCode.LI]: {
        code: CountryCode.LI,
        name: 'Liechtenstein',
        provinces: [],
    },
    [CountryCode.LT]: {
        code: CountryCode.LT,
        name: 'Lithuania',
        provinces: [],
    },
    [CountryCode.LU]: {
        code: CountryCode.LU,
        name: 'Luxembourg',
        provinces: [],
    },
    [CountryCode.MO]: {
        code: CountryCode.MO,
        name: 'Macao',
        provinces: [],
    },
    [CountryCode.MK]: {
        code: CountryCode.MK,
        name: 'Macedonia, The Former Yugoslav Republic of',
        provinces: [],
    },
    [CountryCode.MG]: {
        code: CountryCode.MG,
        name: 'Madagascar',
        provinces: [],
    },
    [CountryCode.MW]: {
        code: CountryCode.MW,
        name: 'Malawi',
        provinces: [],
    },
    [CountryCode.MY]: {
        code: CountryCode.MY,
        name: 'Malaysia',
        provinces: mapProvinces(MALAYSIA_PROVINCE_CODES),
    },
    [CountryCode.MV]: {
        code: CountryCode.MV,
        name: 'Maldives',
        provinces: [],
    },
    [CountryCode.ML]: { code: CountryCode.ML, name: 'Mali', provinces: [] },
    [CountryCode.MT]: {
        code: CountryCode.MT,
        name: 'Malta',
        provinces: [],
    },
    [CountryCode.MQ]: {
        code: CountryCode.MQ,
        name: 'Martinique',
        provinces: [],
    },
    [CountryCode.MR]: {
        code: CountryCode.MR,
        name: 'Mauritania',
        provinces: [],
    },
    [CountryCode.MU]: {
        code: CountryCode.MU,
        name: 'Mauritius',
        provinces: [],
    },
    [CountryCode.YT]: {
        code: CountryCode.YT,
        name: 'Mayotte',
        provinces: [],
    },
    [CountryCode.MX]: {
        code: CountryCode.MX,
        name: 'Mexico',
        provinces: mapProvinces(MEXICO_PROVINCE_CODES),
    },
    [CountryCode.MD]: {
        code: CountryCode.MD,
        name: 'Moldova, Republic of',
        provinces: [],
    },
    [CountryCode.MC]: {
        code: CountryCode.MC,
        name: 'Monaco',
        provinces: [],
    },
    [CountryCode.MN]: {
        code: CountryCode.MN,
        name: 'Mongolia',
        provinces: [],
    },
    [CountryCode.MS]: {
        code: CountryCode.MS,
        name: 'Montserrat',
        provinces: [],
    },
    [CountryCode.MA]: {
        code: CountryCode.MA,
        name: 'Morocco',
        provinces: [],
    },
    [CountryCode.MZ]: {
        code: CountryCode.MZ,
        name: 'Mozambique',
        provinces: [],
    },
    [CountryCode.MM]: {
        code: CountryCode.MM,
        name: 'Myanmar',
        provinces: [],
    },
    [CountryCode.NA]: {
        code: CountryCode.NA,
        name: 'Namibia',
        provinces: [],
    },
    [CountryCode.NR]: {
        code: CountryCode.NR,
        name: 'Nauru',
        provinces: [],
    },
    [CountryCode.NP]: {
        code: CountryCode.NP,
        name: 'Nepal',
        provinces: [],
    },
    [CountryCode.NL]: {
        code: CountryCode.NL,
        name: 'Netherlands',
        provinces: [],
    },
    [CountryCode.AN]: {
        code: CountryCode.AN,
        name: 'Netherlands Antilles',
        provinces: [],
    },
    [CountryCode.NC]: {
        code: CountryCode.NC,
        name: 'New Caledonia',
        provinces: [],
    },
    [CountryCode.NZ]: {
        code: CountryCode.NZ,
        name: 'New Zealand',
        provinces: mapProvinces(NEW_ZEALAND_PROVINCE_CODES),
    },
    [CountryCode.NI]: {
        code: CountryCode.NI,
        name: 'Nicaragua',
        provinces: [],
    },
    [CountryCode.NE]: {
        code: CountryCode.NE,
        name: 'Niger',
        provinces: [],
    },
    [CountryCode.NG]: {
        code: CountryCode.NG,
        name: 'Nigeria',
        provinces: [],
    },
    [CountryCode.NU]: { code: CountryCode.NU, name: 'Niue', provinces: [] },
    [CountryCode.NF]: {
        code: CountryCode.NF,
        name: 'Norfolk Island',
        provinces: [],
    },
    [CountryCode.NO]: {
        code: CountryCode.NO,
        name: 'Norway',
        provinces: mapProvinces(NORWAY_PROVINCE_CODES),
    },
    [CountryCode.OM]: { code: CountryCode.OM, name: 'Oman', provinces: [] },
    [CountryCode.PK]: {
        code: CountryCode.PK,
        name: 'Pakistan',
        provinces: [],
    },
    [CountryCode.PS]: {
        code: CountryCode.PS,
        name: 'Palestinian Territory, Occupied',
        provinces: [],
    },
    [CountryCode.PA]: {
        code: CountryCode.PA,
        name: 'Panama',
        provinces: [],
    },
    [CountryCode.PG]: {
        code: CountryCode.PG,
        name: 'Papua New Guinea',
        provinces: [],
    },
    [CountryCode.PY]: {
        code: CountryCode.PY,
        name: 'Paraguay',
        provinces: mapProvinces(PARAGUAY_PROVINCE_CODES),
    },
    [CountryCode.PE]: {
        code: CountryCode.PE,
        name: 'Peru',
        provinces: mapProvinces(PERU_PROVINCE_CODES),
    },
    [CountryCode.PH]: {
        code: CountryCode.PH,
        name: 'Philippines',
        provinces: [],
    },
    [CountryCode.PN]: {
        code: CountryCode.PN,
        name: 'Pitcairn',
        provinces: [],
    },
    [CountryCode.PL]: {
        code: CountryCode.PL,
        name: 'Poland',
        provinces: [],
    },
    [CountryCode.PT]: {
        code: CountryCode.PT,
        name: 'Portugal',
        provinces: mapProvinces(PORTUGAL_PROVINCE_CODES),
    },
    [CountryCode.QA]: {
        code: CountryCode.QA,
        name: 'Qatar',
        provinces: [],
    },
    [CountryCode.RE]: {
        code: CountryCode.RE,
        name: 'Reunion',
        provinces: [],
    },
    [CountryCode.RO]: {
        code: CountryCode.RO,
        name: 'Romania',
        provinces: [],
    },
    [CountryCode.RU]: {
        code: CountryCode.RU,
        name: 'Russian Federation',
        provinces: [],
    },
    [CountryCode.RW]: {
        code: CountryCode.RW,
        name: 'RWANDA',
        provinces: [],
    },
    [CountryCode.SH]: {
        code: CountryCode.SH,
        name: 'Saint Helena',
        provinces: [],
    },
    [CountryCode.KN]: {
        code: CountryCode.KN,
        name: 'Saint Kitts and Nevis',
        provinces: [],
    },
    [CountryCode.LC]: {
        code: CountryCode.LC,
        name: 'Saint Lucia',
        provinces: [],
    },
    [CountryCode.PM]: {
        code: CountryCode.PM,
        name: 'Saint Pierre and Miquelon',
        provinces: [],
    },
    [CountryCode.VC]: {
        code: CountryCode.VC,
        name: 'Saint Vincent and the Grenadines',
        provinces: [],
    },
    [CountryCode.WS]: {
        code: CountryCode.WS,
        name: 'Samoa',
        provinces: [],
    },
    [CountryCode.SM]: {
        code: CountryCode.SM,
        name: 'San Marino',
        provinces: [],
    },
    [CountryCode.ST]: {
        code: CountryCode.ST,
        name: 'Sao Tome and Principe',
        provinces: [],
    },
    [CountryCode.SA]: {
        code: CountryCode.SA,
        name: 'Saudi Arabia',
        provinces: [],
    },
    [CountryCode.SN]: {
        code: CountryCode.SN,
        name: 'Senegal',
        provinces: [],
    },
    [CountryCode.SC]: {
        code: CountryCode.SC,
        name: 'Seychelles',
        provinces: [],
    },
    [CountryCode.SL]: {
        code: CountryCode.SL,
        name: 'Sierra Leone',
        provinces: [],
    },
    [CountryCode.SG]: {
        code: CountryCode.SG,
        name: 'Singapore',
        provinces: [],
    },
    [CountryCode.SK]: {
        code: CountryCode.SK,
        name: 'Slovakia',
        provinces: [],
    },
    [CountryCode.SI]: {
        code: CountryCode.SI,
        name: 'Slovenia',
        provinces: [],
    },
    [CountryCode.SB]: {
        code: CountryCode.SB,
        name: 'Solomon Islands',
        provinces: [],
    },
    [CountryCode.SO]: {
        code: CountryCode.SO,
        name: 'Somalia',
        provinces: [],
    },
    [CountryCode.ZA]: {
        code: CountryCode.ZA,
        name: 'South Africa',
        provinces: [],
    },
    [CountryCode.GS]: {
        code: CountryCode.GS,
        name: 'South Georgia and the South Sandwich Islands',
        provinces: [],
    },
    [CountryCode.ES]: {
        code: CountryCode.ES,
        name: 'Spain',
        provinces: mapProvinces(SPAIN_PROVINCE_CODES),
    },
    [CountryCode.LK]: {
        code: CountryCode.LK,
        name: 'Sri Lanka',
        provinces: [],
    },
    [CountryCode.SD]: {
        code: CountryCode.SD,
        name: 'Sudan',
        provinces: [],
    },
    [CountryCode.SR]: {
        code: CountryCode.SR,
        name: 'Suriname',
        provinces: [],
    },
    [CountryCode.SJ]: {
        code: CountryCode.SJ,
        name: 'Svalbard and Jan Mayen',
        provinces: [],
    },
    [CountryCode.SZ]: {
        code: CountryCode.SZ,
        name: 'Swaziland',
        provinces: [],
    },
    [CountryCode.SE]: {
        code: CountryCode.SE,
        name: 'Sweden',
        provinces: mapProvinces(SWEDEN_PROVINCE_CODES),
    },
    [CountryCode.CH]: {
        code: CountryCode.CH,
        name: 'Switzerland',
        provinces: mapProvinces(SWITZERLAND_PROVINCE_CODES),
    },
    [CountryCode.SY]: {
        code: CountryCode.SY,
        name: 'Syrian Arab Republic',
        provinces: [],
    },
    [CountryCode.TW]: {
        code: CountryCode.TW,
        name: 'Taiwan',
        provinces: [],
    },
    [CountryCode.TJ]: {
        code: CountryCode.TJ,
        name: 'Tajikistan',
        provinces: [],
    },
    [CountryCode.TZ]: {
        code: CountryCode.TZ,
        name: 'Tanzania, United Republic of',
        provinces: [],
    },
    [CountryCode.TH]: {
        code: CountryCode.TH,
        name: 'Thailand',
        provinces: [],
    },
    [CountryCode.TL]: {
        code: CountryCode.TL,
        name: 'Timor-Leste',
        provinces: [],
    },
    [CountryCode.TG]: { code: CountryCode.TG, name: 'Togo', provinces: [] },
    [CountryCode.TK]: {
        code: CountryCode.TK,
        name: 'Tokelau',
        provinces: [],
    },
    [CountryCode.TO]: {
        code: CountryCode.TO,
        name: 'Tonga',
        provinces: [],
    },
    [CountryCode.TT]: {
        code: CountryCode.TT,
        name: 'Trinidad and Tobago',
        provinces: [],
    },
    [CountryCode.TN]: {
        code: CountryCode.TN,
        name: 'Tunisia',
        provinces: [],
    },
    [CountryCode.TR]: {
        code: CountryCode.TR,
        name: 'Turkey',
        provinces: [],
    },
    [CountryCode.TM]: {
        code: CountryCode.TM,
        name: 'Turkmenistan',
        provinces: [],
    },
    [CountryCode.TC]: {
        code: CountryCode.TC,
        name: 'Turks and Caicos Islands',
        provinces: [],
    },
    [CountryCode.TV]: {
        code: CountryCode.TV,
        name: 'Tuvalu',
        provinces: [],
    },
    [CountryCode.UG]: {
        code: CountryCode.UG,
        name: 'Uganda',
        provinces: [],
    },
    [CountryCode.UA]: {
        code: CountryCode.UA,
        name: 'Ukraine',
        provinces: [],
    },
    [CountryCode.AE]: {
        code: CountryCode.AE,
        name: 'United Arab Emirates',
        provinces: mapProvinces(UNITED_ARAB_EMIRATES_PROVINCE_CODES),
    },
    [CountryCode.GB]: {
        code: CountryCode.GB,
        name: 'United Kingdom',
        provinces: mapProvinces(UNITED_KINGDOM_PROVINCE_CODES),
    },
    [CountryCode.UM]: {
        code: CountryCode.UM,
        name: 'United States Minor Outlying Islands',
        provinces: [],
    },
    [CountryCode.UY]: {
        code: CountryCode.UY,
        name: 'Uruguay',
        provinces: mapProvinces(URUGUAY_PROVINCE_CODES),
    },
    [CountryCode.UZ]: {
        code: CountryCode.UZ,
        name: 'Uzbekistan',
        provinces: [],
    },
    [CountryCode.VU]: {
        code: CountryCode.VU,
        name: 'Vanuatu',
        provinces: [],
    },
    [CountryCode.VE]: {
        code: CountryCode.VE,
        name: 'Venezuela',
        provinces: mapProvinces(VENEZUELA_PROVINCE_CODES),
    },
    [CountryCode.VN]: {
        code: CountryCode.VN,
        name: 'Viet Nam',
        provinces: [],
    },
    [CountryCode.VG]: {
        code: CountryCode.VG,
        name: 'Virgin Islands, British',
        provinces: [],
    },
    [CountryCode.WF]: {
        code: CountryCode.WF,
        name: 'Wallis and Futuna',
        provinces: [],
    },
    [CountryCode.EH]: {
        code: CountryCode.EH,
        name: 'Western Sahara',
        provinces: [],
    },
    [CountryCode.YE]: {
        code: CountryCode.YE,
        name: 'Yemen',
        provinces: [],
    },
    [CountryCode.ZM]: {
        code: CountryCode.ZM,
        name: 'Zambia',
        provinces: [],
    },
    [CountryCode.ZW]: {
        code: CountryCode.ZW,
        name: 'Zimbabwe',
        provinces: [],
    },
    [CountryCode.AC]: {
        code: CountryCode.AC,
        name: 'Ascension Island',
        provinces: [],
    },
    [CountryCode.BL]: {
        code: CountryCode.BL,
        name: 'St. Barthélemy',
        provinces: [],
    },
    [CountryCode.BQ]: {
        code: CountryCode.BQ,
        name: 'Caribbean Netherlands',
        provinces: [],
    },
    [CountryCode.CW]: {
        code: CountryCode.CW,
        name: 'Curaçao',
        provinces: [],
    },
    [CountryCode.ME]: {
        code: CountryCode.ME,
        name: 'Montenegro',
        provinces: [],
    },
    [CountryCode.MF]: {
        code: CountryCode.MF,
        name: 'St. Martin',
        provinces: [],
    },
    [CountryCode.RS]: {
        code: CountryCode.RS,
        name: 'Serbia',
        provinces: [],
    },
    [CountryCode.SS]: {
        code: CountryCode.SS,
        name: 'South Sudan',
        provinces: [],
    },
    [CountryCode.SX]: {
        code: CountryCode.SX,
        name: 'Sint Maarten',
        provinces: [],
    },
    [CountryCode.TA]: {
        code: CountryCode.TA,
        name: 'Tristan da Cunha',
        provinces: [],
    },
    [CountryCode.XK]: {
        code: CountryCode.XK,
        name: 'Kosovo',
        provinces: [],
    },
    [CountryCode.ZZ]: {
        code: CountryCode.ZZ,
        name: 'Unknown Region',
        provinces: [],
    },
};
export const provinceOptions = Object.entries(geoCountryCodes)
    .map(([code, country]) => {
    const { provinces } = country;
    if (!provinces.length)
        return null;
    const options = provinces
        .map((province) => {
        const value = constructProvinceValue({
            countryCode: code,
            provinceCode: province.code,
        });
        if (!value)
            return null;
        return {
            label: province.name,
            value,
        };
    })
        .filter(isTruthy);
    return {
        label: country.name,
        options,
    };
})
    .filter(isTruthy);
//# sourceMappingURL=countries.js.map